function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { INIT_EXAM, RESET_EXAM, START_EXAM, FINISH_EXAM, EVALUATE_INTERACTION, SET_EXAM_POSITION } from "../actions";
import initialState from "./initialState";
export default function exam() {
    var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState.exam, action = arguments.length > 1 ? arguments[1] : void 0;
    var answers;
    var currentAnswer;
    switch(action.type){
        case INIT_EXAM:
            return {
                id: action.id,
                started: new Date(),
                answers: [],
                position: 0,
                state: "intro"
            };
        case EVALUATE_INTERACTION:
            answers = (state === null || state === void 0 ? void 0 : state.answers.slice()) || [];
            currentAnswer = answers.find(function(a) {
                return a.id === action.id;
            });
            // If the answer is not in the list, add it
            if (!currentAnswer) {
                answers.push({
                    id: action.id,
                    status: action.correct ? 1 : 0,
                    selectedAnswers: action.selectedAnswers.slice()
                });
            } else {
                currentAnswer.status = action.correct ? 1 : 0;
                currentAnswer.selectedAnswers = action.selectedAnswers.slice();
                var answerIndex = answers.findIndex(function(a) {
                    return a.id === action.id;
                });
                answers[answerIndex] = currentAnswer;
            }
            return _objectSpreadProps(_objectSpread({}, state), {
                answers: answers
            });
        case SET_EXAM_POSITION:
            if (!state) {
                return initialState.exam;
            }
            return _objectSpreadProps(_objectSpread({}, state), {
                position: action.position
            });
        case RESET_EXAM:
            return initialState.exam;
        case START_EXAM:
            return _objectSpreadProps(_objectSpread({}, state), {
                state: "running",
                position: 0,
                answers: []
            });
        case FINISH_EXAM:
            return _objectSpreadProps(_objectSpread({}, state), {
                state: "finished"
            });
        default:
            return state;
    }
}
